// The one place the workspace reads Rails' CSRF token (`<meta name="csrf-token">`, printed by
// csrf_meta_tags). Both same-origin clients default to it; feature packages import it rather
// than re-implementing the one-liner. Guarded so the package stays importable in node (tests,
// tooling): no document, no token.
export function readCsrfMetaToken(): string | null {
  if (typeof document === 'undefined') return null
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? null
}
